<template>
  <div class="animated fadeIn" id="list-decomptes">
    <transition name="fade">
      <b-card no-body>
        <div slot="header">
          <i class="fa fa-justify mr-2"></i>
          <strong>{{ mode === 'create' ? 'Création de corbeille' : 'Modifier la corbeille' }}</strong>
        </div>
        <b-card-body class="small-padding">
          <!-- <b-card> -->
          <b-form v-on:submit.prevent="search">
            <!-- Partie dupliquée dans gestion dossier -->
            <b-row>
              <b-col sm="6" class="border-right" >
                <b-alert
                  :show="dismissCountDown"
                  dismissible
                  variant="danger"
                  @dismissed="dismissCountDown=0">
                  {{errors.critere}}
                </b-alert>
                <b-row class="mb-1" v-if="canCreateBasket()">
                  <b-col sm="3">
                    <label for="produit"><strong>Nom de la corbeille : <span class="text-danger">*</span></strong></label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input :disabled="isDisabled()" v-model="basketName" placeholder="Nom de la corbeille"
                                  :class="{hasError: errors.basketName !== ''}"></b-form-input>
                    <span class="field-error">{{ errors.basketName }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col sm="3">
                    <label for="category"><strong>Catégorie : <span class="text-danger">*</span></strong></label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-select :disabled="isDisabled()" id="category" v-model="selectedCategory" :class="{hasError: errors.categorie !== ''}">
                      <b-form-select-option v-if="canCreateBasketForAll()" value="systeme">Système</b-form-select-option>
                      <!-- <b-form-select-option v-if="canCreateBasketForTeam()" value="equipe">Equipe</b-form-select-option> -->
                      <b-form-select-option value="utilisateur">Utilisateur</b-form-select-option>
                    </b-form-select>
                    <span class="field-error">{{ errors.categorie }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col sm="3">
                    <label for="treatment"><strong>Traitement : <span class="text-danger">*</span></strong></label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-select
                      id="treatment"
                      @change="treatmentChanged"
                      :options="traitementOptions"
                      v-model="selectedTraitementId"
                      :class="{hasError: errors.traitement !== ''}"
                      :disabled="isDisabled()">
                    </b-form-select>
                    <span class="field-error">{{ errors.traitement }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-1" v-if="displayDateSinistre">
                  <b-col sm="3">
                    <label for="date_sinistre_du"><strong>Date du sinistre du</strong></label>
                  </b-col>
                  <b-col sm="3">
                    <b-form-input class="input_date" type="date" id="date_sinistre_du" size="sm" v-model="date_sinistre_du"></b-form-input>
                  </b-col>
                  <b-col sm="1">
                    <label for="date_sinistre_au"><strong>Au</strong></label>
                  </b-col>
                  <b-col sm="3">
                    <b-form-input class="input_date" type="date" id="date_sinistre_au" size="sm" v-model="date_sinistre_au"></b-form-input>
                  </b-col>
                  <b-col sm="2" style="margin-top:2px;">
                    <span style="display:table-cell;vertical-align:middle;">
                      <strong style="margin-right:5px">exclus</strong>
                    </span>
                    <span style="display:table-cell;vertical-align:middle;">
                      <b-form-checkbox v-model="exclureDateSinistre" style="margin-left:5px"></b-form-checkbox>
                    </span>
                  </b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col sm="3">
                    <label><strong>Statut dossier : </strong></label>
                  </b-col>
                  <b-col sm="9">
                    <multiselect selectLabel='Appuyer sur entrer pour sélectionner'
                                 selectedLabel='Sélectionné'
                                 deselectLabel='Appuyer sur entrer pour désélectionner'
                                 :close-on-select="false"
                                 v-model="status"
                                 tag-placeholder="Choisissez un status de dossier"
                                 placeholder="Par défaut Tous"
                                 label="name"
                                 track-by="code"
                                 :options="allStatusOption"
                                 :multiple="true"
                                 :taggable="true"
                                 :disabled="isDisabled()">
                    </multiselect>
                  </b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col sm="3">
                    <label><strong>Sous Statut : </strong></label>
                  </b-col>
                  <b-col sm="9">
                    <multiselect selectLabel='Appuyer sur entrer pour sélectionner'
                                 selectedLabel='Sélectionné'
                                 deselectLabel='Appuyer sur entrer pour désélectionner'
                                 :close-on-select="false"
                                 v-model="sousStatus"
                                 tag-placeholder="Choisissez un sous status de dossier"
                                 placeholder="Par défaut Tous"
                                 label="name"
                                 track-by="code"
                                 :options="allSousStatusOption"
                                 :multiple="true"
                                 :taggable="true"
                                 :disabled="isDisabled('sousStatus')">
                    </multiselect>
                  </b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col sm="3">
                    <label><strong>Statut Prest'IJ : </strong></label>
                  </b-col>
                  <b-col sm="9">
                    <multiselect selectLabel='Appuyer sur entrer pour sélectionner'
                                 selectedLabel='Sélectionné'
                                 deselectLabel='Appuyer sur entrer pour désélectionner'
                                 :close-on-select="false"
                                 v-model="statusPrestij"
                                 tag-placeholder="Choisissez un status prest ij"
                                 placeholder="Par défaut Tous"
                                 label="name"
                                 track-by="code"
                                 :options="allStatusPrestij"
                                 :multiple="true"
                                 :taggable="true"
                                 :disabled="isDisabled()">
                    </multiselect>
                  </b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col sm="3">
                    <label for="users"><strong>NIR : </strong></label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-textarea
                      id="nir"
                      type="text"
                      rows="2"
                      placeholder="Vous pouvez saisir plusieurs NIR séparés par des ,"
                      v-model="nir">
                    </b-form-textarea>
                  </b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col sm="3">
                    <label for="team"><strong>Equipes Habilitées : </strong></label>
                  </b-col>
                  <b-col sm="9">
                    <multiselect selectLabel='Appuyer pour sélectionner'
                                 selectedLabel='Sélectionné'
                                 deselectLabel='Appuyer pour désélectionner'
                                 :close-on-select="false"
                                 :searchable="true"
                                 v-model="teams"
                                 tag-placeholder="Choisissez un utilisateur"
                                 placeholder="Par défaut Tous"
                                 label="name"
                                 track-by="code"
                                 :options="allTeams"
                                 :multiple="true"
                                 :taggable="true"
                                 :disabled="isDisabled()">
                    </multiselect>
                  </b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col sm="3">
                    <label><strong>Segment Commercial : </strong></label>
                  </b-col>
                  <b-col sm="9">
                    <multiselect selectLabel='Appuyer sur entrer pour sélectionner'
                                 selectedLabel='Sélectionné'
                                 deselectLabel='Appuyer sur entrer pour désélectionner'
                                 :close-on-select="false"
                                 v-model="segmentsCommerciaux"
                                 tag-placeholder="Choisissez un segment commercial"
                                 placeholder="Par défaut Tous"
                                 label="name"
                                 track-by="code"
                                 :options="allSegmentsCommerciaux"
                                 :multiple="true"
                                 :taggable="true"
                                 :disabled="isDisabled()">
                    </multiselect>
                  </b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col sm="3">
                    <label><strong>Délégation Commerciale : </strong></label>
                  </b-col>
                  <b-col sm="9">
                    <multiselect selectLabel='Appuyer sur entrer pour sélectionner'
                                 selectedLabel='Sélectionné'
                                 deselectLabel='Appuyer sur entrer pour désélectionner'
                                 :close-on-select="false"
                                 v-model="delegations"
                                 tag-placeholder="Choisissez une délégation"
                                 placeholder="Par défaut Tous"
                                 label="name"
                                 track-by="code"
                                 :options="allDelegations"
                                 :multiple="true"
                                 :taggable="true"
                                 :disabled="isDisabled()">
                    </multiselect>
                  </b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col sm="3">
                    <label><strong>Groupe Siren : </strong></label>
                  </b-col>
                  <b-col sm="6">
                    <multiselect selectLabel='Appuyer sur entrer pour sélectionner'
                                 selectedLabel='Sélectionné'
                                 deselectLabel='Appuyer sur entrer pour désélectionner'
                                 :close-on-select="false"
                                 v-model="groupSirens"
                                 tag-placeholder="Choisissez un groupe de siren"
                                 placeholder="Par défaut Tous"
                                 label="name"
                                 track-by="code"
                                 :options="allGroupSirens"
                                 :multiple="true"
                                 :taggable="true"
                                 :disabled="isDisabled()">
                    </multiselect>
                  </b-col>
				          <b-col sm="3" style="margin-top:10px;">
                    <span style="display:table-cell;vertical-align:middle;">
                      <strong style="margin-right: 10px">exclus</strong>
                    </span>
                    <span style="display:table-cell;vertical-align:middle;">
                      <b-form-checkbox v-model="exclureGroupeSiren" style="margin-right: 10px"></b-form-checkbox>
                    </span>
                  </b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col sm="3">
                    <label for="canal"><strong>Canal : </strong></label>
                  </b-col>
                  <b-col sm="9">
                    <multiselect selectLabel='Appuyer sur entrer pour sélectionner' selectedLabel='Sélectionné'
                                 deselectLabel='Appuyer sur entrer pour désélectionner' :close-on-select="false"
                                 v-model="canal" tag-placeholder="Choisissez un canal" placeholder="Par défaut Tous"
                                 label="name" track-by="code" :options="allCanals" :multiple="true"
                                 :taggable="true" :disabled="isDisabled()"></multiselect>
                  </b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col sm="3">
                    <label for="segment"><strong>Segment Gestion : </strong></label>
                  </b-col>
                  <b-col sm="9">
                    <multiselect selectLabel='Appuyer sur entrer pour sélectionner' selectedLabel='Sélectionné'
                                 deselectLabel='Appuyer sur entrer pour désélectionner' :close-on-select="false"
                                 v-model="segment" tag-placeholder="Choisissez un segment" placeholder="Par défaut Tous"
                                 label="name" track-by="code" :options="allSegments" :multiple="true"
                                 :taggable="true" :disabled="isDisabled()"></multiselect>
                  </b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col sm="3">
                    <label for="type"><strong>Type Dossier : </strong></label>
                  </b-col>
                  <b-col sm="9">
                    <multiselect selectLabel='Appuyer sur entrer pour sélectionner' selectedLabel='Sélectionné'
                                 deselectLabel='Appuyer sur entrer pour désélectionner' :close-on-select="false"
                                 v-model="type" tag-placeholder="Choisissez un type" placeholder="Par défaut Tous"
                                 label="name" track-by="code" :options="allTypes" :multiple="true"
                                 :taggable="true" :disabled="isDisabled()"></multiselect>
                  </b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col sm="3">
                    <label for="produit"><strong>Famille produit : </strong></label>
                  </b-col>
                  <b-col sm="9">
                    <multiselect selectLabel='Appuyer sur entrer pour sélectionner' selectedLabel='Sélectionné'
                                 deselectLabel='Appuyer sur entrer pour désélectionner' :close-on-select="false"
                                 v-model="produit" tag-placeholder="Choisissez un produit" placeholder="Par défaut Tous"
                                 label="name" track-by="code" :options="allProduits" :multiple="true" group-values="sousOption" group-label="groupe" :group-select="true"
                                 :taggable="true" :disabled="isDisabled()"></multiselect>
                  </b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col sm="3">
                    <label for="produit"><strong>Campagne Qualité : </strong></label>
                  </b-col>
                  <b-col sm="9">
                    <multiselect selectLabel='Appuyer sur entrer pour sélectionner'
                                 selectedLabel='Sélectionné'
                                 deselectLabel='Appuyer sur entrer pour désélectionner'
                                 :close-on-select="false"
                                 v-model="campagnes"
                                 tag-placeholder="Choisissez une campagne"
                                 placeholder="Par défaut Tous"
                                 label="name"
                                 track-by="code"
                                 :options="allCampagnes" :multiple="true"
                                 :taggable="true"
                                 :disabled="isDisabled()"></multiselect>
                  </b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col sm="3">
                    <label><strong>SIREN : </strong></label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input :disabled="isDisabled()" type="text" placeholder="Saisir un SIREN" id="siren" v-model="siren"></b-form-input>
                  </b-col>
                  <b-col sm="2">
                    <label for="nic"><strong>NIC :</strong></label>
                  </b-col>
                  <b-col sm="3">
                      <b-form-input type="text" id="nic" v-model="nic" placeholder="Saisir un NIC"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col sm="3">
                    <label><strong>Dossier(s) Id(s) : </strong></label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input :disabled="isDisabled()" type="text" placeholder="Saisir un ou plusieurs id - Séparés par virgule ','" id="dossierIds" v-model="dossierIds"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col sm="3">
                    <label for="oag"><strong>OAG : </strong></label>
                  </b-col>
                  <b-col sm="9">
                    <multiselect selectLabel='Appuyer sur entrer pour sélectionner'
                                 selectedLabel='Sélectionné'
                                 deselectLabel='Appuyer sur entrer pour désélectionner'
                                 :close-on-select="false"
                                 v-model="oags"
                                 tag-placeholder="Choisissez un OAG"
                                 placeholder="Par défaut Tous"
                                 label="name"
                                 track-by="code"
                                 id="oag"
                                 :options="oagOptions" :multiple="true"
                                 :taggable="true"
                                 :disabled="isDisabled()"></multiselect>
                  </b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col sm="3">
                    <label for="oap"><strong>OAP : </strong></label>
                  </b-col>
                  <b-col sm="9">
                    <multiselect selectLabel='Appuyer sur entrer pour sélectionner'
                                 selectedLabel='Sélectionné'
                                 deselectLabel='Appuyer sur entrer pour désélectionner'
                                 :close-on-select="false"
                                 v-model="oaps"
                                 tag-placeholder="Choisissez un OAP"
                                 placeholder="Par défaut Tous"
                                 label="name"
                                 track-by="code"
                                 id="oap"
                                 :options="oapOptions" :multiple="true"
                                 :taggable="true"
                                 :disabled="isDisabled()"></multiselect>
                  </b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col sm="3">
                    <label for="flag"><strong>Flag : </strong></label>
                  </b-col>
                  <b-col sm="9">
                    <multiselect selectLabel='Appuyer sur entrer pour sélectionner'
                      selectedLabel='Sélectionné'
                      deselectLabel='Appuyer sur entrer pour désélectionner'
                      :close-on-select="false"
                      v-model="flag"
                      tag-placeholder="Choisissez un flag"
                      placeholder="Choisissez un flag"
                      label="name"
                      track-by="code"
                      :options="flagOptions"
                      :multiple="true"
                      :taggable="true"
                      :disabled="isDisabled()">
                    </multiselect>
                  </b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col sm="3">
                    <label for="TypeUrgence"><strong>Type Urgence</strong></label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-group>
                      <multiselect selectLabel='Appuyer sur entrer pour sélectionner'
                        selectedLabel='Sélectionné'
                        deselectLabel='Appuyer sur entrer pour désélectionner'
                        :close-on-select="false"
                        v-model="typeUrgence"
                        tag-placeholder="Choisissez un type"
                        placeholder="Choisissez un type"
                        label="name"
                        track-by="code"
                        :options="typeUrgenceOptions"
                        :multiple="true"
                        :taggable="true"
                        :disabled="isDisabled()">
                      </multiselect>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col sm="3">
                    <label for="rar"><strong>Règle de cumul</strong></label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-group>
                      <b-form-select v-model="selectedRegleCumul" :options="regleCumulOptions" :disabled="isDisabled()">
                        <template v-slot:first>
                          <b-form-select-option :value="''" >-- Choisir une règle --</b-form-select-option>
                        </template>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col sm="3">
                    <label for="affiliation"><strong>Code PTZ</strong></label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-group>
                      <multiselect selectLabel='Appuyer sur entrer pour sélectionner'
                                 selectedLabel='Sélectionné'
                                 deselectLabel='Appuyer sur entrer pour désélectionner'
                                 :close-on-select="false"
                                 v-model="codesPtz"
                                 tag-placeholder="Choisissez un OAP"
                                 placeholder="Par défaut Tous"
                                 label="name"
                                 track-by="code"
                                 id="oap"
                                 :options="codePtzOptions" :multiple="true"
                                 :taggable="true"></multiselect>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col sm="3">
                    <label><strong>Couleur : </strong></label>
                  </b-col>
                  <b-col sm="9">
                    <chrome-picker v-if="!isDisabled()" v-model="colors" @input="updateValue" v-show="showColorPicker"/>
                    <div id="colorPreview"></div>
                    <!-- <b-form-input id='couleur' type='text' v-model="colors.hex" @input="updateValue"></b-form-input> -->
                    <img @click="colorPicker()" id="colorPicker" src="@/assets/images/color_picker_icon_30.png">
                  </b-col>
                </b-row>
                <hr>
                <b-row class="mb-2">
                  <b-col sm="8">
                    <label for="delai_traitement">
                      <strong>Objectif de délai max de traitement : </strong>
                    </label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input :disabled="isDisabled()" type="number" min="0" id="delai_traitement" v-model="delai_traitement" :class="{hasError: errors.delai_traitement !== ''}"></b-form-input>
                    <span class="field-error">{{ errors.delai_traitement }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col sm="8">
                    <label for="delai_en_attente">
                      <strong>Objectif de délai max au statut "En attente" : </strong>
                    </label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input :disabled="isDisabled()" type="number" min="0" id="delai_en_attente" v-model="delai_en_attente" :class="{hasError: errors.delai_traitement !== ''}"></b-form-input>
                    <span class="field-error">{{ errors.delai_en_attente }}</span>
                  </b-col>
                </b-row>
                <div class="footer borded-top mt-1">
                  <div v-if="mode === 'create'" style="display: inline-block;" class="pull-right">
                    <b-button v-if="canCreateBasket()" type="button" @click.prevent="save" size="md" variant="primary" class="">
                      <i class="fa fa-save"></i> Enregistrer
                    </b-button>
                  </div>
                  <div v-if="mode === 'modify' && canModifyBasket()" style="display: inline-block;" class="pull-right">
                    <b-button :disabled="!canModifyBasket()" type="button" @click.prevent="save" size="md" variant="primary" class="">
                      <i class="fa fa-save"></i> Modifier
                    </b-button>
                  </div>
                  <b-button type="button" @click.prevent="clearForm()" size="md" variant="secondary" class="pull-right mr-2">
                    <span v-if="mode === 'create'"><i class="fa fa-eraser"></i> Effacer</span>
                    <span v-else><i class="fa fa-times"></i> Fermer la visualisation de la corbeille</span>
                  </b-button>
                </div>
              </b-col>
              <b-col sm="6"  style="overflow-y: hidden; height: 100vh;">
                <VuePerfectScrollbar class="scroll-area" :settings="psSettings" @ps-scroll-y="scrollHandle">
                  <h5>Liste des corbeilles systèmes</h5>
                  <SlickList lockAxis="y" v-model="systemBaskets" class="list-group" :useDragHandle="true" @sort-end="">
                    <item-list :style="`background-color: ${basket.couleur}`" v-for="(basket, index) in systemBaskets" :index="index" :key="index" :item="basket"
                               >{{ basket.libelle }}
                               <i v-if="canDeleteBasket(basket)" title="Supprimer" class="icon fa fa-trash float-right text-danger" @click="deleteBasket(basket)"></i>
                               <i v-if="canModifyThisBasket(basket)" class="icon fa fa-pencil float-right mr-2" @click="edit(basket)" title="Modifier"></i>
                               <i v-else class="icon fa fa-search float-right mr-2" @click="edit(basket)" title="Voir"></i>
                    </item-list>
                  </SlickList>
                  <h5 v-if="userBaskets.length > 0" class="mt-2">Liste de vos corbeilles</h5>
                  <SlickList lockAxis="y" v-model="userBaskets" class="list-group" :useDragHandle="true" @sort-end="">
                    <item-list :style="`background-color: ${basket.couleur}`" v-for="(basket, index) in userBaskets" :index="index" :key="index" :item="basket"
                               >{{ basket.libelle }}
                               <i v-if="canDeleteBasket(basket)" title="Supprimer" class="icon fa fa-trash float-right text-danger" @click="deleteBasket(basket)"></i>
                               <i class="icon fa fa-pencil float-right mr-2" @click="edit(basket)" title="Modifier"></i>
                    </item-list>
                  </SlickList>
                </VuePerfectScrollbar>
              </b-col>
            </b-row>
          </b-form>
          <!-- </b-card> -->
        </b-card-body>
      </b-card>
    </transition>
  </div>
</template>
<script>
  import {getBaseUrl, getProvider, getIdToken, getAccessToken, getUser} from '@/utils/auth';
  import {hasRule, espaceGestionRules as rules} from "@/utils/rulesHelper"
  import searchForm from "@/components/Dossier/SearchForm";
  import Multiselect from 'vue-multiselect';
  import {CoolSelect as AutoSelect} from 'vue-cool-select';
  import {SlickList} from 'vue-slicksort';
  import itemList from '@/components/SortListItem';
  import {Chrome} from 'vue-color';
  import VuePerfectScrollbar from 'vue-perfect-scrollbar';
  import {canSeeCritere} from "@/utils/communHelper";
  import {isEmpty} from "@/utils/fileHelper";

  let colors = {
    hex: '#fcd5b5',
    hsl: {h: 27, s: 0.92, l: 0.85, a: 1},
    hsv: {h: 27, s: 0.92, v: 0.85, a: 1},
    rgba: {r: 252, g: 213, b: 181, a: 1},
    a: 1
  };

  export default {
    components: {
      searchForm,
      Multiselect,
      AutoSelect,
      SlickList,
      itemList,
      'chrome-picker': Chrome,
      VuePerfectScrollbar
    },
    data() {
      return {
        canSeeCritere,
        mode: 'create',
        basketId: null,
        selectedBasket: null,
        userId: null,
        dismissCountDown: 0,
        showDismissibleAlert: false,
        dismissSecs: 10,
        allBaskets: [],
        systemBaskets: [],
        userBaskets: [],
        showColorPicker: false,
        couleur: '',
        listOrders: [],
        nir: '',
        timeoutId: null,
        noData: false,
        produit: [],
        allProduits: [],
        selectedProduits: [],
        segment: [],
        allSegments: [],
        selectedSegments: [],
        canal: [],
        allCanals: [],
        selectedCanals: [],
        type: [],
        allTypes: [],
        selectedTypes: [],
        garantie: '',
        status: [],
        allStatus: [],
        allStatusOption: [],
        selectedStatus: [],
        sousStatus: [],
        allSousStatusOption: [],
        selectedSousStatus: [],
        statusPrestij: [],
        allStatusPrestij: [],
        selectedStatusPrestij: [],
        selectedCategory: '',
        traitementOptions: [],
        selectedTraitementId: '',
        allTraitements : [],
        teams: [],
        allTeams: [],
        teamSelectOptions: [],
        selectedTeams: [],
        selectedAffectedTeam: '',
        segmentsCommerciaux: [],
        allSegmentsCommerciaux: [],
        selectedSegmentsCommerciaux: [],
        delegations: [],
        allDelegations: [],
        selectedDelegations: [],
        delai_traitement: 0,
        delai_en_attente: 0,
        groupSirens: [],
        allGroupSirens: [],
        selectedGroupSirens: [],
		    exclureGroupeSiren: '',
        exclureDateSinistre: '',
        campagnes: [],
        allCampagnes: [],
        selectedCampagnes: [],
        oags: [],
        allTypesUrgence: [],
        typeUrgence: [],
        typeUrgenceOptions: [{ code : 'urgences_directions', name : 'Urgences Directions'}, { code : 'lignes_rouges', name : 'Lignes Rouges'}, { code : 'fiche_telephonique', name : 'Fiche Tél Webhelp'}, { code : 'mog', name : 'MOG'}],
        selectedTypesUrgences: [],
        allOags: [],
        oagOptions: [],
        selectedOags: [],
        oaps: [],
        allOaps: [],
        oapOptions: [],
        selectedOaps: [],
        siren: '',
        nic: '',
        dossierIds: '',
        basketName: '',
        colors,
        allRegleCumul: [],
        regleCumulOptions: [],
        selectedRegleCumul: [],
        allFlags: [],
        flag: [],
        flagOptions: [],
        selectedFlags: [],
        date_sinistre_du: '',
        date_sinistre_au: '',
        displayDateSinistre: false,
        codesPtz: [],
        allCodePtz: [],
        codePtzOptions: [],
        selectedCodePtz: [],
        errors: {
          basketName: '',
          categorie: '',
          traitement: '',
           delai_traitement: '',
           delai_en_attente: '',
        }
      };
    },
    computed: {
      psSettings: () => {
        // ToDo: find better rtl fix
        return {
          maxScrollbarLength: 200,
          minScrollbarLength: 40,
          suppressScrollX: getComputedStyle(document.querySelector('html')).direction !== 'rtl',
          wheelPropagation: false,
          interceptRailY: styles => ({ ...styles, height: 0 })
        }
      }
    },
    watch: {
      systemBaskets: function (newVal, oldVal) {
        // console.log('oldVal',oldVal)
        // console.log('newVal',newVal)
        if (oldVal.length > 0 && newVal.length > 0) {
          this.sorted()
        }
      },
      userBaskets: function (newVal, oldVal) {
        if (oldVal.length > 0 && newVal.length > 0) {
          this.sorted()
        }
      },
      selectedTraitementId: function(){
        this.displayDateSinistre = false;
        if(this.selectedTraitementId){
          if (this.allTraitements.length > 0) {
            let traitementDeces = this.allTraitements.find(traitement => traitement.libelle_technique === 'gestion_dc');

            let traitementInval = this.allTraitements.find(traitement => traitement.libelle_technique === 'gestion_inval');
            let traitementIj = this.allTraitements.find(traitement => traitement.libelle_technique === 'ij_gestion_prestation');
            let traitementIjModulePrev = this.allTraitements.find(traitement => traitement.libelle_technique === 'ij_module_prevoyance');

            if(this.selectedTraitementId === traitementDeces.id
              || this.selectedTraitementId === traitementInval.id
              || this.selectedTraitementId === traitementIj.id
              || this.selectedTraitementId === traitementIjModulePrev.id){
              this.displayDateSinistre = true;
            }else{
              this.date_sinistre_du = '';
              this.date_sinistre_au = '';
            }
          }
          
        }
      },
      users: function () {
        if (this.users) {
          this.selectedUsers = this.users.map(item => item.code);
        } else {
          this.selectedUsers = [];
        }
      },
      teams: function () {
        if (this.teams) {
          this.selectedTeams = this.teams.map(item => item.code);
        } else {
          this.selectedTeams = [];
        }
      },
      status: function() {
        if (this.status) {
          this.selectedStatus = this.status.map( item => item.code);
          this.getSousStatus()
        } else {
          this.selectedStatus = [];
        }
      },
      sousStatus: function() {
        if (this.sousStatus) {
          this.selectedSousStatus = this.sousStatus.map( item => item.code)
        } else {
          this.selectedSousStatus = []
        }
      },
      statusPrestij: function () {
        if (this.statusPrestij) {
          this.selectedStatusPrestij = this.statusPrestij.map(item => item.code);
        } else {
          this.selectedStatusPrestij = [];
        }
      },
      delegations: function () {
        if (this.delegations) {
          this.selectedDelegations = this.delegations.map(item => item.code);
        } else {
          this.selectedDelegations = [];
        }
      },
      segmentsCommerciaux: function () {
        if (this.segmentsCommerciaux) {
          this.selectedSegmentsCommerciaux = this.segmentsCommerciaux.map(item => item.code);
        } else {
          this.selectedSegmentsCommerciaux = [];
        }
      },
      groupSirens: function () {
        if (this.groupSirens) {
          this.selectedGroupSirens = this.groupSirens.map(item => item.code);
        } else {
          this.selectedGroupSirens = [];
        }
      },
      canal: function () {
        if (this.canal) {
          this.selectedCanals = this.canal.map(item => item.code)
        } else {
          this.selectedCanals = []
        }
      },
      type: function () {
        if (this.type) {
          this.selectedTypes = this.type.map(item => item.code)
        } else {
          this.selectedTypes = []
        }
      },
      segment: function () {
        if (this.segment) {
          this.selectedSegments = this.segment.map(item => item.code)
        } else {
          this.selectedSegments = []
        }
      },
      produit: function () {
        if (this.produit) {
          this.selectedProduits = this.produit.map(item => item.code)
        } else {
          this.selectedProduits = []
        }
      },
      campagnes: function () {
        if (this.delegations) {
          this.selectedCampagnes = this.campagnes.map(item => item.code);
        } else {
          this.selectedCampagnes = [];
        }
      },
      oags: function () {
        if (this.oags) {
          this.selectedOags = this.oags.map(item => item.code);
        } else {
          this.selectedOags = [];
        }
      },
      oaps: function () {
        if (this.oaps) {
          this.selectedOaps = this.oaps.map(item => item.code);
        } else {
          this.selectedOaps = [];
        }
      },
      typeUrgence: function() {
        if (this.typeUrgence) {
          this.selectedTypesUrgences = this.typeUrgence.map( item => item.code)
        } else {
          this.selectedTypesUrgences = []
        }
      },
      flag: function () {
        if (this.flag) {
          this.selectedFlags = this.flag.map(item => item.code);
        } else {
          this.selectedFlags = [];
        }
      },
      codesPtz: function () {
        if (this.codesPtz) {
          this.selectedCodePtz = this.codesPtz.map(item => item.code);
        } else {
          this.selectedCodePtz = [];
        }
      },
    },
    async created() {
      this.$axios.defaults.baseURL = getBaseUrl()
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + ' ' + getAccessToken()
      this.$axios.defaults.headers.common["Accept"] = "application/json"
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.addEventToColorPicker();

      if (this.$route.query.status) {
        this.selectedStatus = this.$route.query.status
        this.populateStatus()
      }
      if (this.$route.query.sousStatus) {
        this.selectedSousStatus = this.$route.query.sousStatus
        this.getSousStatus()
        this.populateSousStatus()
      }
      if (this.$route.query.segment) {
        this.selectedSegments = this.$route.query.segment
      }
      if (this.$route.query.type) {
        this.selectedTypes = this.$route.query.type
        this.populateType()
      }
      if (this.$route.query.canal) {
        this.selectedCanals = this.$route.query.canal
        this.populateCanal()
      }
      if (this.$route.query.produit) {
        this.selectedProduits = this.$route.query.produit
        this.populateProduit()
      }
      if (this.$route.query.garantie) {
        this.garantie = this.$route.query.garantie
      }
      if (this.$route.query.traitementId) {
        this.selectedTraitementId = this.$route.query.traitementId
      }
      if (this.$route.query.siren) {
        this.siren = this.$route.query.siren;
      }
      if (this.$route.query.nic) {
        this.nic = this.$route.query.nic;
      }
      if (this.$route.query.dossierIds) {
        this.dossierIds = this.$route.query.dossierIds;
      }
      if (this.$route.query.team) {
        this.selectedAffectedTeam = this.$route.query.team;
      }
      if (this.$route.query.segmentsCommerciaux) {
        this.selectedSegmentsCommerciaux = this.$route.query.segmentsCommerciaux;
        this.populateSegmentCommerciaux();
      }
      if (this.$route.query.delegations) {
        this.selectedDelegations = this.$route.query.delegations;
        this.populateDelegation();
      }
      if (this.$route.query.statusPrestij) {
        this.selectedStatusPrestij = this.$route.query.statusPrestij;
        this.populateStatusPrestij();
      }
      if (this.$route.query.groupSirens) {
        this.selectedGroupSirens = this.$route.query.groupSirens;
        this.populateGroupSiren();
      }
	    if (this.$route.query.exclureGroupeSiren) {
        this.exclureGroupeSiren = this.$route.query.exclureGroupeSiren
      }
	    if (this.$route.query.exclureDateSinistre) {
        this.exclureDateSinistre = this.$route.query.exclureDateSinistre
      }
      if (this.$route.query.campagnes) {
        // console.log('campagnes : ', this.$route.query.campagnes);
        this.selectedCampagnes = this.$route.query.campagnes;
        this.populateCampagne();
      }
      if (this.$route.query.oags) {
        this.selectedOags = this.$route.query.oags
        this.populateOags();
      }
      if (this.$route.query.oaps) {
        this.selectedOaps = this.$route.query.oaps
        this.populateOaps()
      }
      if (this.$route.query.regleCumul) {
        this.selectedRegleCumul = this.$route.query.regleCumul
      }
      if (this.$route.query.typeUrgence) {
        this.selectedTypesUrgences = this.$route.query.typeUrgence;
        this.populateTypeUrgence();
      }
      if (this.$route.query.flag) {
        this.selectedFlags = this.$route.query.flag
        this.populateFlag();
      }
      if (this.$route.query.codesPtz) {
        this.selectedCodePtz = this.$route.query.codesPtz
        this.populateCodePtz();
      }
    },
    async mounted() {
      let preview = document.getElementById('colorPreview')
      preview.style.backgroundColor = this.colors.hex

      // await this.getTeams();
      await this.getDataInputSerach()
      this.getSousStatus();
      this.getBaskets();
      // repeuplement du form suite retour d'une fiche
      this.populateStatus();
      this.populateSousStatus();
      this.populateSegment();
      this.populateType();
      this.populateCanal();
      this.populateDelegation();
      this.populateSegmentCommerciaux();
      this.populateGroupSiren();
      this.populateStatusPrestij();
      this.populateProduit();
      this.populateCampagne();
      this.populateTeams();
      this.populateOags();
      this.populateOaps();
      this.getReglesCumul()
      this.populateTypeUrgence()
      this.populateFlag()
      this.populateCodePtz()

      if (!this.canCreateBasketForTeam() && !this.canCreateBasketForAll()) {
        this.selectedCategory = 'utilisateur'
      }
    },
    methods: {
      scrollHandle (evt) {
        // console.log(evt)
      },
      updateValue() {
        let preview = document.getElementById('colorPreview')
        preview.style.backgroundColor = this.colors.hex
      },
      colorPicker() {
        this.showColorPicker = !this.showColorPicker;
        if (this.showColorPicker) {
          let colorWheel = document.getElementById('colorPicker')
          let posWheel = colorWheel.getBoundingClientRect()
          let colorPicker = document.getElementsByClassName('vc-chrome')[0]
          let posColorPicker = colorPicker.getBoundingClientRect()
          colorPicker.style.top = '-242px'//'10px'
          colorPicker.style.left = (posWheel.x - 462) + 'px'
        }
      },
      nameWithProfile({name, profile}) {
        return `${name} — [${profile}]`
      },
      async getDataInputSerach() {
        let self = this;
        this.$store.commit("IS_LOADING", true)
        await this.$axios
          .get("/espaceGestion/dossier/getDataInputSerach")
          .then(response => {
            this.$store.commit("IS_LOADING", false)
            this.allStatus = response.data.status
            // console.log('status', response.data)
            for (let status of this.allStatus) {
              this.allStatusOption.push({code: status.id, name: status.libelle_bo})
            }
            this.traitements = response.data.traitements
            this.allTraitements = response.data.traitements
            let user = getUser()
            // console.log(user)
            let traitementIds = user.profil_active[0].traitements.map((traitement) => traitement.id)
            let traitementPrincipaux = response.data.traitements.reduce((res,traitement) => {
              if (traitement.type === 'Principal') {
                res.push(traitement);
              }
              return res;
            },[]);
            let traitementSecondaire = response.data.traitements.reduce((res,traitement) => {
              if (traitement.type === 'Secondaire') {
                res.push(traitement);
              }
              return res;
            },[]);
            let optionsPrincipaux = [];
            for (let traitement of traitementPrincipaux) {
              if (traitementIds.indexOf(traitement.id) >= 0) {
                optionsPrincipaux.push({value: traitement.id, text: traitement.libelle});
              }
            }
            this.traitementOptions.push({label: 'Traitements principaux', options: optionsPrincipaux})
            let optionsSecondaires = [];
              for (let traitement of traitementSecondaire) {
                optionsSecondaires.push({value: traitement.id, text: traitement.libelle})
              }
            optionsSecondaires.sort((a,b) => (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0));
            this.traitementOptions.push({label: 'Traitements secondaires', options: optionsSecondaires})

            for(let canal of response.data.canals){
              this.allCanals.push({code: canal.id, name: canal.libelle})
            }
            for(let type of response.data.types){
              this.allTypes.push({code: type.id, name: type.libelle})
            }
            for(let segment of response.data.segments){
              this.allSegments.push({code: segment.id, name: segment.libelle})
            }
            let sousOptionProduit = [];
            for(let produit of response.data.produits){
              sousOptionProduit.push({code: produit.id, name: produit.libelle})
            }
            this.allProduits.push({groupe: 'Tous', sousOption: sousOptionProduit})
            for (let status of response.data.statusPrestij) {
              this.allStatusPrestij.push({code: status.id, name: status.libelle});
            }
            for (let segment of response.data.segmentsCommerciaux) {
              this.allSegmentsCommerciaux.push({code: segment.id, name: segment.libelle})
            }
            for (let delegation of response.data.delegations) {
              this.allDelegations.push({code: delegation.id, name: delegation.nom})
            }
            for (let groupSiren of response.data.groupSirens) {
              this.allGroupSirens.push({code: groupSiren.id, name: groupSiren.libelle})
            }
            for (let campagne of response.data.campagnes) {
              this.allCampagnes.push({code: campagne.id, name: campagne.libelle})
            }

            let userOags = user.profil_active[0].oags.map(oag => oag.code);
            this.allOags = response.data.oags
            for (let oag of response.data.oags) {
              if (userOags.indexOf(oag.code) > -1) {
                this.oagOptions.push({code: oag.code, name: oag.code + ' (' + oag.structure.libelle + ')'});
              }
            }
            let userOaps = user.profil_active[0].oaps.map(oap => oap.code);
            this.allOaps = response.data.oaps
            for (let oap of response.data.oaps) {
              if (oap.structure && oap.structure !== null) {
                if (userOaps.indexOf(oap.code) > -1) {
                  this.oapOptions.push({code: oap.code, name: oap.code + ' (' + oap.structure.libelle + ')'});
                }
              }
            }
            for (let team of response.data.equipes) {
              this.allTeams.push({code: team.id, name: team.libelle})
              this.teamSelectOptions.push({value: team.id, text: team.libelle})
            }
            for (let flag of response.data.flags) {
              this.flagOptions.push({code: flag.id, name: flag.libelle})
            }
            this.allCodePtz = response.data.codesPtz;
            for (let code of response.data.codesPtz) {
              if(code.code_blocage) {
                this.codePtzOptions.push({code: code.code_blocage, name: code.code_blocage});
              }
            }
          })
          .catch((error) => {
            console.log(error)
            self.handleErrors(self);
          });
      },
      getBaskets() {
        this.systemBaskets = [];
        this.userBaskets = [];
        let self = this;
        this.$store.commit("IS_LOADING", true)
        this.$axios
          .get("/espaceGestion/dossier/getAllUserBasket/monActiviteProd")
          .then(response => {
            // console.log(response.data)
            this.$store.commit("IS_LOADING", false)
            this.systemBaskets = response.data.data.systeme !== undefined ? response.data.data.systeme : []
            this.userBaskets = response.data.data.utilisateur ? response.data.data.utilisateur : []
            // this.allBaskets = response.data.data
          })
          .catch((err) => {
            console.log('err ===> ', err)
            self.handleErrors(self);
          })
      },
      treatmentChanged() {
        // this.allUsers = []
        // this.selectedUsers = []
        // this.getUsers()
      },
      getSousStatus() {
        this.allSousStatusOption = [];
        // console.log('dans getSousStatus, this.selectedStatus',this.selectedStatus)
        for (let statusId of this.selectedStatus) {
          for (let status of this.allStatus) {
            // console.log('dans getSousStatus, status',status)
            if (parseInt(statusId,10) === status.id) {
              for (let sousStatus of status.sous_statuts) {
                this.allSousStatusOption.push({code: sousStatus.id, name: sousStatus.libelle_bo});
              }
            }
          }
        }
      },
      populateCanal() {
        this.populateData('canal', 'allCanals', 'selectedCanals');
      },
      populateUsers() {
        this.users = [];
        for (let id of this.selectedUsers) {
          let name = "";
          let profile = "";
          for (let element of this.allUsers) {
            if (element.code === parseInt(id)) {
              name = element.name;
              profile = element.profile;
            }
          }
          this.users.push({code: id, name: name, profile: profile});
        }
      },
      populateStatus() {
        this.populateData('status', 'allStatusOption', 'selectedStatus');
      },
      populateSousStatus() {
        this.populateData('sousStatus', 'allSousStatusOption', 'selectedSousStatus');
      },
      populateTeams() {
        this.populateData('teams', 'allTeams', 'selectedTeams');
      },
      populateStatusPrestij() {
        this.populateData('statusPrestij', 'allStatusPrestij', 'selectedStatusPrestij');
      },
      populateSegment() {
        this.populateData('segment', 'allSegments', 'selectedSegments');
      },
      populateSegmentCommerciaux() {
        this.populateData('segmentsCommerciaux', 'allSegmentsCommerciaux', 'selectedSegmentsCommerciaux');
      },
      populateDelegation() {
        this.populateData('delegations', 'allDelegations', 'selectedDelegations');
      },
      populateGroupSiren() {
        this.populateData('groupSirens', 'allGroupSirens', 'selectedGroupSirens');
      },
      populateType() {
        this.populateData('type', 'allTypes', 'selectedTypes');
      },
      populateFlag() {
        this.populateData('flag', 'flagOptions', 'selectedFlags');
      },
      populateProduit() {
        // this.populateData('produit', 'allProduits', 'selectedProduits');
        // console.log(this.allProduits)
        this.produit = [];
        for (let id of this.selectedProduits) {
          let name = "";
          for (let element of this.allProduits[0].sousOption) {
            if (element.code === parseInt(id)) {
              name = element.name
            }
          }
          this.produit.push({code: id, name: name});
        }
      },
      populateCampagne() {
        this.populateData('campagnes', 'allCampagnes', 'selectedCampagnes');
      },
      populateOags() {
        this.oags = [];
        for (let id of this.selectedOags) {
          let name = "";
          for (let element of this.oagOptions) {
            if (element.code === id) {
              name = element.name
            }
          }
          this.oags.push({code: id, name: name});
        }
      },
      populateOaps() {
        this.oaps = [];
        for (let id of this.selectedOaps) {
          let name = "";
          for (let element of this.oapOptions) {
            if (element.code === id) {
              name = element.name
            }
          }
          this.oaps.push({code: id, name: name});
        }
      },
      populateCodePtz() {
        this.codesPtz = [];
        for (let code of this.selectedCodePtz) {
          let name = "";
          for (let element of this.codePtzOptions) {
            if (element.code === code) {
              name = element.name
            }
          }
          this.codesPtz.push({code: code, name: name});
        }
      },
      clearForm() {
        this.clearErrors()
        this.basketId = null
        this.selectedBasket = null
        this.userId = null
        this.mode = 'create'
        this.selectedCategory = ''
        this.nir = ''
        this.basketName = ''
        this.basketForAll = ''
        this.produit = []
        this.selectedProduits = []
        this.segment = []
        this.selectedSegments = []
        this.canal = []
        this.selectedCanals = []
        this.type = []
        this.status = []
        this.selectedStatus = []
        this.sousStatus = []
        this.selectedSousStatus = []
        // this.selectedUsers = []
        // this.allUsers = []
        // this.users = []
        this.selectedTeams = []
        this.selectedAffectedTeam = ''
        // this.allTeams = []
        this.teams = []
        this.selectedTypes = []
        this.selectedTraitementId = ''
        this.statusPrestij = []
        this.selectedStatusPrestij = []
        this.groupSirens = []
        this.selectedGroupSirens = []
        this.delegations = []
        this.selectedDelegations = []
        this.segmentsCommerciaux = []
        this.selectedSegmentsCommerciaux = []
        this.campagnes = []
        this.selectedCampagnes = []
        this.oags = []
        this.selectedTypesUrgences = []
        this.selectedOags = []
        this.oaps = []
        this.selectedOaps = []
        this.siren = ''
        this.dossierIds = ''
        this.delai_traitement = 0
        this.delai_en_attente = 0
        this.selectedRegleCumul = []
        this.flag = []
        this.selectedFlags = []
        this.nic = ''
        this.codesPtz = []
        this.selectedCodePtz = []
        // this.colors.hex = '#fcd5b5'
        // this.updateValue()
      },
      save() {
        if (this.validateSave()) {
          let self = this
          let dataPost = {
            'basketId': this.basketId,
            'userId': this.userId,
            'basketName': this.basketName,
            'produit': this.selectedProduits,
            'segment': this.selectedSegments,
            'canal': this.selectedCanals,
            'type': this.selectedTypes,
            'categorie': this.selectedCategory,
            'traitement': this.selectedTraitementId,
            'date_sinistre_du': this.date_sinistre_du,
            'date_sinistre_au': this.date_sinistre_au,
            'users': this.selectedUsers,
            'delai_traitement': this.delai_traitement,
            'delai_en_attente': this.delai_en_attente,
            'group_siren': this.selectedGroupSirens,
			      'exclureGroupeSiren': this.exclureGroupeSiren,
            'exclureDateSinistre': this.exclureDateSinistre,
            'status_prestij': this.selectedStatusPrestij,
            'statusId': this.selectedSousStatus.length > 0 ? this.selectedSousStatus : this.selectedStatus,
            'segment_commercial': this.selectedSegmentsCommerciaux,
            'delegation': this.selectedDelegations,
            'campagne': this.selectedCampagnes,
            'oags': this.selectedOags,
            'oaps': this.selectedOaps,
            'typeUrgence' : this.selectedTypesUrgences,
            'equipes': this.selectedTeams,
            'selectedTeam': this.selectedAffectedTeam,
            'siren': this.siren,
            'nic': this.nic,
            'dossierIds': this.dossierIds,
            'nir': this.nir,
            'couleur': this.colors.hex,
            'regleCumul': this.selectedRegleCumul,
            'flag': this.selectedFlags,
            'codesPtz': this.selectedCodePtz
          };
          // console.log('dataPost', dataPost)
          this.$store.commit("IS_LOADING", true);
          this.$axios
            .post("/espaceGestion/dossier/storeBasket", dataPost)
            .then(() => {
              this.$store.commit("IS_LOADING", false);
              this.$swal({
                position: 'top',
                type: 'success',
                title:'',
                text: this.mode === 'modify' ? 'Modifications bien enregistrées' : 'Corbeille créée avec succès',
                showConfirmButton: false,
                timer: 3000
              });
              this.getBaskets()
              this.clearForm()
            })
            .catch((err) => {
              console.log('err ===> ', err);
              self.handleErrors(self)
            });
        }
      },
      edit(basket) {
        this.clearErrors()
        this.basketId = basket.id
        this.selectedBasket = basket
        this.userId = basket.user_id
        this.mode = 'modify'
        // console.log(basket)
        // console.log(this.allStatus)
        this.basketName = basket.libelle
        // this.forWho = basket.is_for_all ? 'forAll' : basket.is_for_team ? 'forTeam' : basket.is_personal ? 'personal' : ''
        this.selectedProduits = basket.criteres.produit
        this.selectedSegments = basket.criteres.segment
        this.selectedCanals = basket.criteres.canal
        this.selectedTypes = basket.criteres.type
        this.selectedTraitementId = basket.traitement_id
        this.date_sinistre_du = basket.criteres.date_sinistre_du
        this.date_sinistre_au = basket.criteres.date_sinistre_au
        this.selectedGroupSirens = basket.criteres.group_siren
		    this.exclureGroupeSiren = basket.criteres.exclureGroupeSiren == 1 ? true : false;
        this.exclureDateSinistre = basket.criteres.exclureDateSinistre == 1 ? true : false;
        this.selectedStatusPrestij = basket.criteres.status_prestij
        this.selectedSegmentsCommerciaux = basket.criteres.segment_commercial
        this.selectedDelegations = basket.criteres.delegation
        this.selectedCampagnes = basket.criteres.campagne
        this.selectedOags = basket.criteres.oags ? basket.criteres.oags : []
        this.selectedOaps = basket.criteres.oaps ? basket.criteres.oaps : []
        this.selectedTypesUrgences = basket.criteres.typeUrgence ? basket.criteres.typeUrgence : []
        this.selectedTeams = basket.equipes.length > 0 ? basket.equipes.map(equipe => equipe.id) : []
        this.selectedAffectedTeam = basket.criteres.selectedTeam
        this.selectedCategory = basket.categorie
        this.delai_traitement = !isEmpty(basket.delai_traitement) ? basket.delai_traitement : null
        // this.getUsers()
        this.delai_en_attente = !isEmpty(basket.delai_en_attente) ? basket.delai_en_attente : null
        this.siren = !isEmpty(basket.siren) ? basket.siren : null
        this.nic = !isEmpty(basket.nic) ? basket.nic : null
        this.dossierIds = basket.criteres.dossierIds
        this.nir = basket.criteres.nir
        this.colors.hex = !isEmpty(basket.couleur) ? basket.couleur : null
        this.selectedRegleCumul = basket.criteres.regleCumul
        this.selectedFlags = basket.criteres.flag ? basket.criteres.flag : []
        this.selectedCodePtz = basket.criteres.codesPtz ? basket.criteres.codesPtz : []
        // Si on a un critère de status, il faut recalculer les infos de statut et sous statut
        let statusParentId = [];
        let sousStatusId = [];
        if (basket.criteres.statusId.length > 0) {
          let statusId = basket.criteres.statusId.map(elem=> parseInt(elem, 10));
          let statuts = this.allStatus.filter(status => statusId.indexOf(status.id) > -1);
          if (statuts.length === 0) {
            for (let statusParent of this.allStatus) {
              for (let sousStatus of statusParent.sous_statuts) {
                if (statusId.indexOf(sousStatus.id) > -1) {
                  sousStatusId.push(sousStatus.id);
                  statusParentId = [sousStatus.parent_id];
                }
              }
            }
          } else {
            statusParentId = statuts.map(status => status.id);
          }
        }
        this.selectedStatus = statusParentId;
        this.selectedSousStatus = sousStatusId;
        this.populateStatus();
        this.getSousStatus();
        this.populateSousStatus();
        this.updateValue()
        // this.selectedUsers = basket.authorized_users !== null ? basket.authorized_users.split(',') : []
        // this.populateUsers()
        this.populateSegment();
        this.populateType()
        this.populateCanal();
        this.populateDelegation();
        this.populateSegmentCommerciaux();
        this.populateGroupSiren();
        this.populateStatusPrestij();
        this.populateProduit();
        this.populateCampagne();
        this.populateTeams();
        this.populateOags();
        this.populateOaps();
        this.populateTypeUrgence();
        this.populateFlag();
        this.populateCodePtz();
      },
      deleteBasket(basket) {
        let self = this;
        this.$swal
          .fire({
            title: "Êtes-vous sûr?",
            text: "Voulez-vous vraiment supprimer cette corbeille ?",
            type: "warning",
            reverseButtons: true,
            showCancelButton: true,
            allowOutsideClick: false,
            cancelButtonColor: "#ff1744",
            confirmButtonText: "Annuler",
            cancelButtonText: "Supprimer"
          })
          .then(result => {
            if (!result.value) {
              this.$store.commit("IS_LOADING", true)
              this.$axios
                .get("/espaceGestion/dossier/basket/delete/"+basket.id).then(response => {
                  this.$store.commit("IS_LOADING", false)
                  this.getBaskets()
                  this.$swal({
                      position: 'top',
                      type:'success',
                      title:'',
                      text:'Corbeille suprimée avec succès',
                      showConfirmButton: false,
                      timer: 5000
                    })
                })
                .catch(function(error) {
                    self.$store.commit('IS_LOADING', false)
                    console.log(error)
                    let errorText = 'Une erreur est survenue, lors de la suppression de la corbeille. Si le problème persiste, merci de faire un ticket au support DOSI.'
                    if (error.response.status === 403) { errorText = 'Vous n\'êtes pas autorisé à effectuer cette action' }
                    self.$swal({
                      position: 'top',
                      type:'error',
                      title:'Attention !!',
                      text:errorText,
                      showConfirmButton: false,
                      timer: 5000
                    })
                })
            }
          })
      },
      canCreateBasket() {
        return hasRule(rules.CAN_CREATE_BASKET_DOSSIER)
      },
      canCreateBasketForTeam() {
        let user = getUser()
        let responsable = false
        for (let equipe of user.equipes) {
          if (equipe.pivot.role === 'responsable') {
            responsable = true
          }
        }
        return hasRule(rules.CAN_CREATE_BASKET_DOSSIER) && responsable
      },
      canCreateBasketForAll() {
        return hasRule(rules.CAN_CREATE_BASKET_FOR_ALL_DOSSIER)
      },
      canDeleteBasket(basket) {
        let user = getUser()
        return (user.id === basket.user_id || hasRule(rules.CAN_CREATE_BASKET_FOR_ALL_DOSSIER))
      },
      canModifyBasket() {
        let user = getUser()
        let basket = this.systemBaskets.filter(b => b.id === this.basketId)[0]
        if (basket === undefined) {
          basket = this.userBaskets.filter(b => b.id === this.basketId)[0]
        }
        return (user.id === basket.user_id || hasRule(rules.CAN_CREATE_BASKET_FOR_ALL_DOSSIER))
      },
      canModifyThisBasket(basket) {
        let user = getUser()

        return (user.id === basket.user_id || hasRule(rules.CAN_CREATE_BASKET_FOR_ALL_DOSSIER))
      },
      canManageService() {
        return hasRule(rules.CAN_MANAGE_SERVICE)
      },
      getCreator(basket) {
        return basket.user.prenom.substring(0, 1).toUpperCase() + '. ' + basket.user.nom.toUpperCase()
      },
      isDisabled(field) {
        let disabled = false
        if (this.mode === 'create' && !hasRule(rules.CAN_CREATE_BASKET_DOSSIER)) {
          disabled =  true
        }
        if (this.mode !== 'create' && !this.canModifyThisBasket(this.selectedBasket)) {
          disabled =  true
        }

        if (field === 'sousStatus' && this.status.length !== 1) {
          disabled =  true
        }
        return disabled
      },
      sorted() {
        let self = this;
        let baskets = []
        if (this.systemBaskets !== [] && this.userBaskets !== []) {
          baskets = this.systemBaskets.concat(this.userBaskets)
        }
        // On n'enregistre le tri que si les deux tableaux sont présents
        if (baskets !== []) {
          let dataPost = {
            'provider': getProvider(),
            'baskets': baskets
          }
          this.$store.commit('IS_LOADING', true)
          this.$axios
            .post('/espaceGestion/basket/userSort', dataPost)
            .then(() => {
              this.$store.commit('IS_LOADING', false)
            })
            .catch((err) => {
              console.log('err ===> ', err)
              self.handleErrors(self);
            });
        }
      },
      validate() {
        let error = false;
        if (this.selectedUsers.length === 0
          && this.siren === ''
          && this.dossierIds === ''
          && this.nir === ''
          && this.selectedAffectedTeam === ''
          && this.date_sinistre_du === ''
          && this.date_sinistre_au === ''
          && this.selectedGroupSirens.length === 0
          && this.selectedProduits.length === 0
          && this.selectedStatusPrestij.length === 0
          && this.selectedDelegations.length === 0
          && this.selectedCanals.length === 0
          && this.selectedTypes.length === 0
          && this.selectedSegments.length === 0
          && this.selectedCampagnes.length === 0
          && this.selectedOags.length === 0
          && this.selectedOaps.length === 0
          && this.selectedSegmentsCommerciaux.length === 0
          && this.selectedRegleCumul.length === 0
          && this.selectedFlags.length === 0
          && this.selectedCodePtz.length === 0) {
          this.dismissCountDown = this.dismissSecs;
          error = true;
          this.errors.critere = 'Vous devez sélectionner au moins un critère de recherche';
        }
        return !error;
      },
      validateSave() {
        let error = false;
        // error = !this.validate();
        if (this.basketName === '') {
          error = true
          this.errors.basketName = 'Vous devez entrer un nom de corbeille'
        }
        if (this.selectedCategory === '') {
          error = true;
          this.errors.categorie = 'Vous devez choisir une catégorie';
        }
        if (this.selectedTraitementId === '') {
          error = true;
          this.errors.traitement = 'Vous devez choisir un traitement';
        }

        /*
        if (isNaN(parseFloat(this.delai_traitement))) {
          error = true;
          this.errors.delai_traitement = 'Vous devez entrer un délai de traitement au format numérique';
        }else if(this.delai_traitement < 0 ){
          error = true;
          this.errors.delai_traitement = 'Vous devez entrer un délai de traitement au format numérique positif';
        }

        if (isNaN(parseFloat(this.delai_en_attente))) {
          error = true;
          this.errors.delai_en_attente = 'Vous devez entrer un délai pour le statut "En attente" au format numérique';
        }else if(this.delai_en_attente < 0 ){
          error = true;
          this.errors.delai_en_attente = 'Vous devez entrer un délai pour le statut "En attente"au format numérique positif';
        }*/

        // if (this.forWho === '') {
        //   error = true;
        //   this.errors.forWho = 'Vous devez choisir un destinataire';
        // }
        // if (this.delai_traitement === 0) {
        //   error = true;
        //   this.errors.delai_traitement = 'Vous devez entrer un délai de traitement maximum';
        // }
        // if (this.delai_en_attente === 0) {
        //   error = true;
        //   this.errors.delai_en_attente = 'Vous devez entrer un délai pour le statut "en attente" maximum';
        // }
        return !error;
      },
      clearErrors() {
        this.errors.critere = ''
        this.errors.basketName = ''
        this.errors.categorie = ''
        this.errors.traitement = ''
        // this.errors.forWho = ''
        this.errors.delai_traitement = ''
        this.errors.delai_en_attente = ''
        this.dismissCountDown = 0
      },
      handleErrors(self) {
        self.$store.commit("IS_LOADING", false)
        self.$swal({
          position: "top",
          type: "error",
          title: "Attention !!",
          text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
          showConfirmButton: false,
          timer: 5000
        })
      },
      populateTypeUrgence() {
        this.typeUrgence = [];
        if (this.selectedTypesUrgences !== undefined) {
          for (let libelleTechnique of this.selectedTypesUrgences) {
            let name = "";
            for (let element of this.typeUrgenceOptions) {
              if (element.code === libelleTechnique) {
                name = element.name
              }
            }
            this.typeUrgence.push({code: libelleTechnique, name: name});
          }
        }
      },
      populateData(data, allData, selectedData) {
        this[data] = [];
        for (let id of this[selectedData]) {
          let name = "";
          for (let element of this[allData]) {
            if (element.code === parseInt(id)) {
              name = element.name
            }
          }
          this[data].push({code: id, name: name});
        }
      },
      addEventToColorPicker() {
        document.addEventListener('keyup', (evt) => {
          if (evt.keyCode === 27 || evt.keyCode === 13) {
            this.showColorPicker = false;
          }
        });
      },
      getReglesCumul() {
        let self = this;
        this.$axios
          .get("/espaceGestion/dossier/getReglesCumul")
          .then(response => {
            this.allRegleCumul = response.data.data;
            this.regleCumulOptions.push({value: 'tous', text: 'Toutes les règles de cumul'});
            for (let regleCumul of response.data.data) {
              this.regleCumulOptions.push({value: regleCumul.libelle_technique, text: regleCumul.libelle});
            }
          })
          .catch(() => {
            self.handleErrors(self);
          });
      },
    }
  };
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
  .scroll-area {
    position: absolute;
    height: 100%;
    width: 90%;
    /*margin: auto;*/
  }
  /*.ps__thumb-y, .ps__rail-y:hover > .ps__thumb-y {
    background-color: #4285F4;
  }*/
  .form-control.inline, .inline {
    width: auto;
    display: inline-block;
  }

  .loading-indicator {
    width: 20px;
  }

  .smaller {
    font-size: 0.9em;
  }

  .forMe {
    background-color: #90ee9080;
  }

  .forTeam {
    background-color: #ffa5006b;
  }

  .forAll {
    background-color: #ff180042;
  }

  legend {
    font-weight: bolder;
  }

  #couleur {
    width: 90%;
    display: inline-block;
    vertical-align: middle;
  }

  #colorPreview {
    width: 85%;
    height: 30px;
    border: 1px solid #EEEEEE;
    display: inline-block;
    vertical-align: middle;
  }

  #colorPicker {
    margin-left: 5px;
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
  }

  .circle {
    width: 30px;
    height: 30px;
    background: #194d33;
    border-radius: 50%;
  }

  .vc-chrome {
    position: absolute;
    z-index: 10;
  }
</style>
